$(document).ready(function () {
    // Sticky Header on scroll
    $(function () {
        var header = $("header");
        $(window).scroll(function () {
            var scroll = $(window).scrollTop();
            var headerHeight = $('header').height();
            if (scroll > headerHeight + 1) {
                header.addClass("scrolled");
            } else {
                header.removeClass("scrolled");
            }
        });
    });

    var $burgerNav = $('#burger-nav');
    var $navigation = $('.navigation');
    var $searchToggle = $('.search-toggle');
    var $searchForm = $('.search-form');
    var $header = $('header');

    function isBurgerVisible() {
        return $burgerNav.is(':visible');
    }

    function setNavState(isOpen) {
        if (!isBurgerVisible()) {
            return;
        }

        var headerHeight = $('header').height();
        var navHeight = "calc(100vh - " + headerHeight + "px)";

        $burgerNav.toggleClass('open', isOpen);
        $navigation.toggleClass('open', isOpen);
        $searchToggle.toggleClass('open', isOpen);
        $navigation.css({ 'height': navHeight });
        $('body').toggleClass('no-scroll', isOpen);
        $burgerNav.attr('aria-expanded', isOpen ? 'true' : 'false');
    }

    function setSearchState(isOpen) {
        $searchToggle.toggleClass('is-active', isOpen);
        $searchForm.toggleClass('is-open', isOpen);
        $header.toggleClass('search-open', isOpen);
        $searchToggle.attr('aria-expanded', isOpen ? 'true' : 'false');
    }

    // Mobile nav show/hide
    $burgerNav.on('click', function () {
        if (!isBurgerVisible()) {
            return;
        }

        var willOpen = !$burgerNav.hasClass('open');

        if (willOpen) {
            setSearchState(false);
        }

        setNavState(willOpen);
    });

    $searchToggle.on('click', function (e) {
        e.preventDefault();
        var willOpen = !$searchToggle.hasClass('is-active');

        if (willOpen && isBurgerVisible()) {
            setNavState(false);
        }

        setSearchState(willOpen);
    });

    $(document).on('click', function (e) {
        if (!$(e.target).closest('.search-toggle, .search-form').length) {
            setSearchState(false);
        }
    });

    $(document).on('keyup', function (e) {
        if (e.key === 'Escape') {
            setSearchState(false);
        }
    });

    // Mobile nav submenu dropdowns
    if ($(window).width() < 992) {
        $('.menu-item-has-children').click(function(e) {
            var submenu = $(this).children('.sub-menu');
            e.stopPropagation(); 
            $(this).toggleClass('active');
            submenu.toggleClass('open');
        });
        $('.menu-item-has-children > a').click(function(event) {
            var submenu = $(this).siblings('.sub-menu');
            if (submenu.hasClass('open')) {
                window.location.href = $(this).attr('href');
            } else {
                event.preventDefault();
            }
        });
    }
});
